export default {
  NONE: '',
  READY_TO_UPLOAD: 'Ready to upload.',
  UPLOADING: 'Uploading',
  PENDING: 'Pending',
  COMPLETE: 'Complete'
}
